import classNames from "classnames"
import React from "react"

export type NavbarDesktopProps = React.HTMLAttributes<HTMLDivElement>

export const NavbarDesktop = ({ children, className }: NavbarDesktopProps) => (
  <nav className={classNames("navbar__desktop", className)}>{children}</nav>
)
